








import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class UiHeader extends Vue {
  @Prop(String)
  public title!: string;
  @Prop(String)
  public subtitle!: string;
}
